<!-- Barra de menu-->
<navbar-component></navbar-component>

<main class="background">

  <!-- Cabeçalho -->
  <div class="head">
    <img src="./../../assets/icons/pesquisadores_head.svg" alt="Ícone Pesquisadores" id="head-icon">
    <div class="container-title">
      <div class="title">
        Pesquisadores
      </div>
    </div>
  </div>

  <div class="container">
    <!-- Corpo do conteúdo na página -->
    <div class="retangulo2">

      <!-- Pesquisador 7 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_7.png" alt="Foto Renata" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Renata Garcia Wanderley</p>
              <span class="curriculo">
                <a href="http://lattes.cnpq.br/4838831648200377" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Resíduos Têxteis: Nutrientes Criativos<br>
                • Lavanderia têxtil: beneficiando tecidos e reconstruindo resíduos / <br> Resíduos
                têxteis de Lavanderias: a construção de uma nova atividade produtiva<br>
                • Moda e Plástico: resíduos indiretos, efeitos negativos diretos / <br> Nutrientes
                Criativos: resíduos plásticos e retalhos de tecidos sintéticos<br>
                • Design + Economia Criativa + Economia da Cultura: uma abordagem estratégica de desenvolvimento
              </span>
            </div>

          </div>
        </div>
      </div>


      <!-- Pesquisador 2 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_2.png" alt="Foto Camila" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Camila Brito de Vasconcelos</p>
              <span class="curriculo">
                <a href="http://lattes.cnpq.br/9158673599744458" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Resíduos Têxteis: Nutrientes Criativos<br>
                • Lavanderia têxtil: beneficiando tecidos e reconstruindo resíduos
              </span>
            </div>

          </div>
        </div>
      </div>

      <!-- Pesquisador 3 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_3.png" alt="Foto Cecilia" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Cecilia da Rocha Pessôa</p>
              <span class="curriculo">
                <a href="http://lattes.cnpq.br/8869019537743428" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Resíduos Têxteis: Nutrientes Criativos
              </span>
            </div>

          </div>
        </div>
      </div>


      <!-- Pesquisador 5 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_5.png" alt="Foto Lais" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Lais Helena Gouveia Rodrigues</p>
              <span class="curriculo">
                <a href="http://lattes.cnpq.br/3118783612217279" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Resíduos Têxteis: Nutrientes Criativos<br>
                • Lavanderia têxtil: beneficiando tecidos e reconstruindo resíduos / <br> Resíduos
                têxteis de Lavanderias: a construção de uma nova atividade produtiva<br>
                • Moda e Plástico: resíduos indiretos, efeitos negativos diretos / <br> Nutrientes
                Criativos: resíduos plásticos e retalhos de tecidos sintéticos<br>
                • Design + Economia Criativa + Economia da Cultura: uma abordagem estratégica de desenvolvimento
              </span>
            </div>

          </div>
        </div>
      </div>

      <!-- Pesquisador 11 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_11.png" alt="Foto Rani" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Rani Duarte</p>
              <span class="curriculo">
                <a href="http://lattes.cnpq.br/2060251082497950" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Design + Economia Criativa + Economia da Cultura: uma abordagem estratégica de desenvolvimento
              </span>
            </div>

          </div>
        </div>
      </div>

      <!-- Pesquisador 10 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_10.png" alt="Foto Rebecca" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Rebecca Menezes</p>
              <span class="curriculo">
                <a href="http: //lattes.cnpq.br/4421582203319341" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Design + Economia Criativa + Economia da Cultura: uma abordagem estratégica de desenvolvimento
              </span>
            </div>

          </div>
        </div>
      </div>

      <!-- Pesquisador 9 -->
      <div class="col s12 m8">
        <div class="card-panel transparent">
          <div class="row valign-wrapper">

            <!-- Foto do pesquisador -->
            <img src="./../../assets/fotos/pessoa_9.png" alt="Foto Vicente" class="responsive-img">
            <!-- Currículo -->
            <div class="col s10 barra-de-texto">
              <p class="nome-completo">Vicente Luiz de Azevedo</p>
              <span class="curriculo">
                <a href="http://lattes.cnpq.br/3828799290199585" target="_blank" rel="noopener noreferrer">Currículo
                  Lattes - CNPq</a><br>
                <b>Projetos:</b><br>
                • Lavanderia têxtil: beneficiando tecidos e reconstruindo resíduos <br>
                • Subprojeto Nutrientes Criativos: fibrilas de algodão de lavanderias <br>
                • Subprojeto Nutrientes Criativos: compósito de fibrilas têxteis - composição, tecnologia e aplicação
                
              </span>
            </div>

          </div>
        </div>
      </div>

      <!-- Final do corpo da página-->
    </div>

  </div>
</main>

<!-- Footer and copyright -->
<footer-component></footer-component>